import { Button, Icon, Shadow, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { newWithdrawalAtom } from '../../../../../../../../store/customerDetail/withdrawal/atom';

export namespace FinishedTypes {
  export interface Props {
    onGoBack: () => void;
    onReset: () => void;
  }
}

export const Finished: React.FC<FinishedTypes.Props> = ({ onGoBack, onReset }) => {
  const withdrawalState = useRecoilValue(newWithdrawalAtom);

  return (
    <VStack space={Spacing['stack.xxxs']}>
      <Shadow level={1} padding={Spacing['inset.md']}>
        <VStack space={Spacing['stack.xxxs']}>
          <VStack alignItems="center" space={Spacing['stack.xxxs']}>
            <Icon name="Success" size="xl" color={Color['feedback.success.default']} />
            <Text fontSize={Typography['fontsize.lg']} variant="semibold">
              Saque solicitado com sucesso.
            </Text>
          </VStack>
          <VStack
            paddingX={Spacing['inset.sm']}
            paddingY={Spacing['inset.xs']}
            space={Spacing['stack.nano']}
            backgroundColor={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.7)}
            borderRadius={BoxRadius.sm}>
            <HStack justifyContent="space-between">
              <Text>Valor de saque:</Text>
              <Text variant="semibold">{Utils.Mask.Money(withdrawalState.value)}</Text>
            </HStack>
            <HStack justifyContent="space-between">
              <Text>Data de solicitação:</Text>
              <Text variant="semibold">
                {Utils.Mask.DateFormat(withdrawalState.requestDate, 'dd/MM/yyyy')}
              </Text>
            </HStack>
            <HStack justifyContent="space-between">
              <Text>Data para saque:</Text>
              <Text variant="semibold">
                {Utils.Mask.DateFormat(withdrawalState.withdrawalDate, 'dd/MM/yyyy')}
              </Text>
            </HStack>
          </VStack>
        </VStack>
      </Shadow>
      <HStack justifyContent="space-between">
        <Button variant="secondary" onPress={onGoBack}>
          Fechar
        </Button>
        <Button variant="primary" onPress={onReset}>
          Novo saque
        </Button>
      </HStack>
    </VStack>
  );
};
